

import React from 'react'
import { Layout } from 'element-react'
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import shop from '../assets/imgs/shop.png';

export default function UnderConstruction() {
    const { t } = useTranslation();
    return (
            <div className='container'>
                <Layout.Row  justify="center" align="middle">
                    <Layout.Col offset="2" xs="24" sm="24" md="24" lg="24">
                        <h1>
                            {window.location.pathname}
                        </h1>
                        <h2>
                            This feature will be available soon!
                        </h2>
                        <h3>
                            Have a question? <a href="/contact-us">contact us</a>
                        </h3>
                    </Layout.Col>
                </Layout.Row>
                <Layout.Row  align="left">
                    <Layout.Col offset="10" xs="24" sm="24" md="24" lg="24">
                        <img src={shop}/>   
                    </Layout.Col>
                </Layout.Row>
            </div>
        
    )
}
